/**
 * LandingPage — Öffentliche Marketing-Landingpage (W4.2)
 *
 * Rendert auf Route `/` wenn User NICHT eingeloggt ist.
 * Layout: .public-layout (kein Sidebar, kein Topbar)
 * SEO: title + meta description via document.title / meta tag
 */
import { useEffect } from 'react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LandingHero } from './LandingHero'
import { LandingFeatures } from './LandingFeatures'
import { LandingCTA } from './LandingCTA'
import { LandingFooter } from './LandingFooter'
import { LandingLanguageSwitcher } from './LandingLanguageSwitcher'
import './landing.css'

export function LandingPage() {
  const { t } = useTranslation('landing')

  // SEO: document.title
  useEffect(() => {
    document.title = t('seo.title')

    // Meta-Description aktualisieren oder anlegen
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'description'
      document.head.appendChild(meta)
    }
    meta.content = t('seo.description')

    return () => {
      document.title = 'HeliumTracker'
    }
  }, [t])

  return (
    <div className="public-layout" data-testid="landing-page">
      {/* Minimaler Header: Logo + Anmelden-Button */}
      <header className="public-header landing-header">
        <div className="public-header__inner">
          <div className="public-header__brand">
            <div className="logo-mark">H</div>
            <span className="public-header__name">HeliumTracker</span>
          </div>
          <nav className="public-header__nav">
            <LandingLanguageSwitcher />
            <Link to="/login" className="btn">
              {t('header.login')}
            </Link>
            <Link to="/register" className="btn btn-primary">
              {t('header.register')}
            </Link>
          </nav>
        </div>
      </header>

      <main className="public-main">
        <LandingHero />
        <LandingFeatures />
        <LandingCTA />
      </main>

      <LandingFooter />
    </div>
  )
}
